import { useEffect } from 'react'
import { captureMarketingAttributionOnce } from './attribution'

/**
 * Captures first-touch UTM / click ids / Meta cookies into sessionStorage
 * on the first app mount of a browser session.
 */
function MarketingAttributionCapture() {
  useEffect(() => {
    captureMarketingAttributionOnce()
  }, [])

  return null
}

export default MarketingAttributionCapture
